export default {
  methods: {
    htmlEntities (str) {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
    }
  }
}



// WEBPACK FOOTER //
// ./src/general.js